import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';

import { UploadService } from '../../../services/upload-progress.service';

@Component({
    selector: 'mapp-upload-progress-bar',
    templateUrl: './upload-progress-bar.component.html',
    styleUrls: ['./upload-progress-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class UploadProgressBarComponent {
    readonly uploadService = inject(UploadService);

    readonly progressWidth = computed(() =>
        Math.max(6, Math.min(100, this.uploadService.progress()))
    );
}
